import en from './en'
import cn from './cn'
export default {
  en,
  cn
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js